import React, { useEffect, useState } from "react";
import {
  Paper,
  Typography,
  Stack,
  TextField,
  Button,
  IconButton,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Link as LinkRRD, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import NoDataFound from "../../common/NoDataFound";
import LoadingUI from "../../common/LoadingUI";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import moment from "moment";
import { useSearchParams } from "react-router-dom";
import AppbarUI from "../../common/AppbarUI";
import BodyWapperUI from "../../common/BodyWapperUI";
import DrawerUI from "../../common/DrawerUI";
import { singleUserTransactionAction } from "../../redux/toolkit/users/singleUserTransaction";
import { userDetailsAction } from "../../redux/toolkit/users/details";

const bull = (
  <Box
    component="span"
    sx={{ display: "inline-block", mx: "2px", transform: "scale(0.8)" }}
  >
    •
  </Box>
);

const SingleUserTransaction = () => {
  const [pageSize, setPageSize] = useState(25);
  const [pageState, setPageState] = useState({ page: 0, pageSize: 25 });

  let dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  const user_id = searchParams.get("user_id");

  const {
    status,
    loading: listLoading,
    data,
    message,
  } = useSelector((state) => state.singleUserTransaction);

  const { data: singleUserData } = useSelector((state) => state.singleUserData);

  let AppColumns = [
    {
      field: "s_no",
      headerName: "S. No.",
      filterable: false,
      flex: 1,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        const { page, pageSize } = pageState;
        const serialNumber =
          page * pageSize + params?.api?.getRowIndex(params.row._id) + 1;
        return serialNumber;
      },
    },

    {
      field: "p_user_id",
      headerName: "User Id",
      flex: 1,
      minWidth: 300,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Typography color="primary">{params?.row?.p_user_id}</Typography>
        );
      },
    },

    {
      field: "app_name",
      headerName: "App Name",
      flex: 1,
      minWidth: 300,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Typography color="primary">
            {params?.row?.app_id?.app_name}
          </Typography>
        );
      },
    },
    {
      field: "trans_id",
      headerName: "Transaction Id",
      flex: 1,
      minWidth: 300,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "user_payout",
      headerName: "User Earning $",
      flex: 1,
      minWidth: 300,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Typography color="primary">
            {Number(params?.row?.user_payout).toFixed(4)}
          </Typography>
        );
      },
    },

    // {
    //   field: "bonus_amt",
    //   headerName: "Boonus Amount",
    //   flex: 1,
    //   minWidth: 300,
    //   headerClassName: "super-app-theme--header",
    //   renderCell: (params) => {
    //     return (
    //       <Typography color="primary">
    //         {Number(params?.row?.bonus_amt).toFixed(4)}
    //       </Typography>
    //     );
    //   },
    // },

    {
      field: "publisher_payout",
      headerName: "Publisher Earning $",
      flex: 1,
      minWidth: 300,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Typography color="primary">
            {Number(params?.row?.publisher_payout).toFixed(4)}
          </Typography>
        );
      },
    },

    {
      field: "raw_amount",
      headerName: "Withdrawal Amount ($)",
      flex: 1,
      minWidth: 300,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Typography color="primary">
            {Number(params?.row?.raw_amount).toFixed(4)}
          </Typography>
        );
      },
    },

    {
      field: "app_id",
      headerName: "App Id",
      flex: 1,
      minWidth: 300,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Typography color="primary">{params?.row?.app_id?._id}</Typography>
        );
      },
    },

    {
      field: "publisher_id",
      headerName: "Publisher Id",
      flex: 1,
      minWidth: 300,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 300,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Typography color="primary">
            {params?.row?.status === 0
              ? "Pending"
              : params?.row?.status === 1
              ? "Success"
              : params?.row?.status === 3
              ? "Screen Out"
              : params?.row?.status === 2
              ? "Failed"
              : "Null"}
          </Typography>
        );
      },
    },

    // {
    //   field: "isPending",
    //   headerName: "isPending",
    //   flex: 1,
    //   minWidth: 300,
    //   headerClassName: "super-app-theme--header",
    //   renderCell: (params) => {
    //     return (
    //       <Typography color="primary">
    //         {params?.row?.isPending === true ? "True" : "False"}
    //       </Typography>
    //     );
    //   },
    // },

    {
      field: "createdAt",
      headerName: "Created At",
      flex: 1,
      minWidth: 300,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Typography color="primary">
            {moment(params?.row?.createdAt).format("DD-MM-YYYY hh:mm:ss A")}
          </Typography>
        );
      },
    },
  ];

  useEffect(() => {
    dispatch(userDetailsAction({ user_id: user_id }));
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      singleUserTransactionAction({
        user_id,
        page: pageState.page,
        limit: pageState.pageSize,
      })
    );
  }, [dispatch, pageState.page, pageState.pageSize]);

  return (
    <>
      <AppbarUI />
      <DrawerUI />

      <BodyWapperUI>
        <h3>Note: Only withdraw transactions will be shown here.</h3>
        {singleUserData?.user_id && (
          <Card sx={{ minWidth: 275, border: " 1px solid #000" }}>
            <CardContent>
              {/* <Typography variant="h5" component="div">
                            email : {singleUserData[0]?.email}
                        </Typography> */}
              <Typography variant="h5" component="div">
                user_id : {singleUserData?.user_id}
              </Typography>
              <Typography variant="h5" component="div">
                earnings : {singleUserData?.totalEarned?.toFixed(4)}
              </Typography>
              <Typography variant="h5" component="div">
                Available To Withdraw : {singleUserData?.availableToWidthdrawal?.toFixed(4)}
              </Typography>
            </CardContent>
          </Card>
        )}

        <Paper
          sx={{
            marginTop: "20px",
            border: " 1px solid #000",
            bgcolor: "#fff",
            "& .super-app-theme--header": {
              background: "rgba(254, 206, 113, 0.16)",
              color: "#000",
              borderBottom: " 1px solid #000",
              fontFamily: "Open Sans",
              fontSize: "13px",
            },
          }}
          elevation={0}
        >
          <DataGrid
            sx={{
              border: 0,
              // "& .MuiDataGrid-row:hover": {
              //     backgroundColor: "#E7F7FF"
              //     // color: "red"
              // }

              "& .MuiDataGrid-row:hover": {
                background: "rgba(254, 206, 113, 0.16)",
                cursor: "pointer",
              },
            }}
            // className={classes.root}
            getRowHeight={({ densityFactor }) => {
              return 70 * densityFactor;
            }}
            autoHeight
            rows={data}
            columns={AppColumns}
            getRowId={(row) => row._id}
            disableSelectionOnClick
            experimentalFeatures={{ newEditingApi: true }}
            rowsPerPageOptions={[25, 50, 75, 100]}
            disableColumnSelector
            loading={listLoading ? <LoadingUI /> : false}
            onCellClick={(params) => {
              // setPublisher_id(params?.row?._id)
            }}
            components={{
              NoRowsOverlay: () => <NoDataFound />,
              // Toolbar: GridToolbar,
            }}
            // rowCount={total}
            paginationModel={setPageState}
            page={pageState.page}
            pageSize={pageState.pageSize}
            paginationMode="server"
            onPageChange={(newPage) => {
              setPageState((old) => ({ ...old, page: newPage }));
            }}
            onPageSizeChange={(newPageSize) =>
              setPageState((old) => ({ ...old, pageSize: newPageSize }))
            }
          />
        </Paper>
      </BodyWapperUI>
    </>
  );
};

export default SingleUserTransaction;
